import { TeamCard } from "@/components/portal/TeamCard";

export default function UsersPage() {
  return (
    <div data-testid="users-page" className="max-w-2xl">
      <TeamCard />
    </div>
  );
}
